import type { ReactiveValue } from './reactive-value.js';
import type { Watcher } from './watch.js';

export interface Consumer {
  deps: Set<ReactiveValue<unknown>>;
  markDirty(): void;
}

const activeConsumers: Consumer[] = [];
const effectWatchers: Watcher[] = [];

export function trackDeps(val: ReactiveValue<unknown>) {
  if (activeConsumers.length > 0) {
    const last = activeConsumers[activeConsumers.length - 1];

    last.deps.add(val);
    val.listeners.add(last);
  }
}

export function activateConsumer(val: Consumer) {
  activeConsumers.push(val);
}

export function deactivateConsumer() {
  activeConsumers.pop();
}

export function activeEffectWatcher(watcher: Watcher) {
  effectWatchers.push(watcher);
}

export function isWatcherExist(watcher: Watcher) {
  return effectWatchers.includes(watcher);
}

export function deactivateWatcher() {
  effectWatchers.pop();
}
